import { useMutation } from '@tanstack/react-query';

import { login, type LoginPayload, type LoginResponse } from '@/api/adapters/auth';
import { useAuthStore } from '@/app/store/auth.store';

/**
 * Login mutation hook.
 *
 * On success: stores token + user info in the auth store.
 * On error: propagates the `ApiError` (from `@/api/error`) to the caller —
 * the page switches on `error.code` per `docs/api-contracts/login.md §1.6`.
 */
export function useLogin() {
  const authLogin = useAuthStore((s) => s.login);

  return useMutation<LoginResponse, Error, LoginPayload>({
    mutationFn: (payload) => login(payload),
    onSuccess: (data) => {
      authLogin(data.accessToken, data.user.email, data.user.name, data.user.role);
    },
  });
}
